import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import BetRadarStream from '@/components/liveStream/betRadarStream/BetRadarStream.vue';
import type { UseLiveStreamEvent, UseLiveStreamProvider } from '@/composable/liveStream/useLiveStream';
import { BetRadarStreamStatus, LiveStreamProvider } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';
import { useToggleStore } from '@/store/toggleStore';

const validStatus = [BetRadarStreamStatus.OnAirBroadcast, BetRadarStreamStatus.OnAirReady, BetRadarStreamStatus.Approved];

export function useBetRadarStream(event: Ref<UseLiveStreamEvent | null>): UseLiveStreamProvider {
    const { isAvApiLiveStreamEnabled, isInLiveStreamWhiteList } = storeToRefs(useToggleStore());
    const { ipCountryCode } = storeToRefs(useCustomerStore());

    const isAvailable = computed(() => {
        if (!event.value?.stream?.betRadar) return false;
        if (!isAvApiLiveStreamEnabled.value) return false;
        if (!isInLiveStreamWhiteList.value && !event.value.stream.betRadar.allowedCountries.includes(ipCountryCode.value)) return false;
        if (!validStatus.includes(event.value.stream.betRadar.streamStatus)) return false;

        return true;
    });

    const isPlayable = computed(() => isAvailable.value && event.value?.stream?.betRadar?.streamStatus === BetRadarStreamStatus.OnAirBroadcast);

    const streamDisplay = computed(() => {
        if (!isPlayable.value || !event.value?.stream?.betRadar) return null;

        return {
            provider: LiveStreamProvider.BetRadar,
            component: BetRadarStream,
            key: event.value.stream.betRadar.eventId.toString(),
            props: {
                betRadar: event.value.stream.betRadar,
            },
        };
    });
    return {
        isAvailable,
        isPlayable,
        streamDisplay,
    };
}
